import BaseServiceCrud from '../BaseServiceCrud';

export default class MobileUserServicePublic extends BaseServiceCrud {
    // Initializing important variables
    constructor() {
        super();
        this.path = 'mobile/user';
    }

    activateEmail(body) {
        // Get a token from api server using the fetch api
        return this.fetch(`${this.domain}/${this.path}/activate-email`, {
            method: 'PUT',
            body: JSON.stringify(body),
        }).then((res) => {
            return Promise.resolve(res);
        });
    }
}
